import createFormModule from '../../utils/createFormModule'
import {
  SET_CURRENT_PASSWORD,
  SET_PASSWORD,
  SET_PASSWORD_CONFIRMATION,
  RESET
} from './types'

const formModule = createFormModule({ resourcePath: '/users/:userId', resourceName: 'user' })

export const state = {
  ...formModule.state,
  form: {
    currentPassword: '',
    password: '',
    passwordConfirmation: ''
  }
}

export const mutations = {
  ...formModule.mutations,
  [SET_CURRENT_PASSWORD] (state, value) {
    state.form.currentPassword = value
  },
  [SET_PASSWORD] (state, value) {
    state.form.password = value
  },
  [SET_PASSWORD_CONFIRMATION] (state, value) {
    state.form.passwordConfirmation = value
  },
  [RESET] (state) {
    state.form.currentPassword = ''
    state.form.password = ''
    state.form.passwordConfirmation = ''
  }
}

export const actions = {
  ...formModule.actions,
  setCurrentPassword ({ commit }, value) {
    commit(SET_CURRENT_PASSWORD, value)
  },
  setPassword ({ commit }, value) {
    commit(SET_PASSWORD, value)
  },
  setPasswordConfirmation ({ commit }, value) {
    commit(SET_PASSWORD_CONFIRMATION, value)
  },
  reset ({ commit }) {
    commit(RESET)
  }
}

export const getters = {
  ...formModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/passwordForm.js